import React from 'react';
import { SpinnerProps } from '../../types/spinner-types';
import { useSpinner } from '../../hooks/useSpinner';

const Spinner: React.FC<SpinnerProps> & {
  start: (id?: string) => void;
  stop: (id?: string) => void;
} = ({
  size = 'medium',
  color = '#3b82f6',
  style = {},
  className = '',
  id = 'GlobalSpinner'
}) => {
  const { spinnerStyle } = useSpinner({ size, color, style });

  return (
    <>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <div id={id} style={spinnerStyle} className={className} />
    </>
  );
};

// Static methods to control spinner
Spinner.start = (id = 'GlobalSpinner') => {
  const spinner = document.getElementById(id || 'GlobalSpinner');
  if (spinner) {
    spinner.style.display = 'block';
  }
};

Spinner.stop = (id = 'GlobalSpinner') => {
  const spinner = document.getElementById(id || 'GlobalSpinner');
  if (spinner) {
    spinner.style.display = 'none';
  }
};

export default Spinner;

